import React, { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import AppLocale from "../../settings/translation";
import actions from "src/store/common/actions";

export const AddTranslationsContext = createContext();

const IntelProviderWrapper = (props) => {
  const { children } = props;

  const dispatch = useDispatch();

  const lang = useSelector((state) => state.common.lang);

  const currentAppLocale = AppLocale[lang];

  // console.log(currentAppLocale);

  const additionalTranslations = useSelector((state) => state.common.additionalTranslations);
  const addTranslations = messages => dispatch(actions.addAdditionalTranslations(messages));


  const intlMessages = {
    ...currentAppLocale.messages,
    ...additionalTranslations?.[lang]
  };

  return (
    <IntlProvider
      locale={"en"}
      textComponent={React.Fragment}
      messages={intlMessages}
    >
      <AddTranslationsContext.Provider value={addTranslations}>
        {children}
      </AddTranslationsContext.Provider>
    </IntlProvider>
  );
};

export default IntelProviderWrapper;
